import {AUTH_TOKEN} from "../../util/constants";
import AuthService from "../../services/AuthService";
import {AUTH_ERROR, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS} from "../actions/auth";


const state = {token: localStorage.getItem(AUTH_TOKEN) || '', status: '', hasLoadedOnce: false}

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
};

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            AuthService.auth(data)
                .then(response => {
                    if (response) {
                        if (response.data.status === 'UNAUTHORIZED') {
                            commit(AUTH_ERROR);
                            localStorage.removeItem(AUTH_TOKEN);
                            reject("El usuario no existe o ha sido deshabilitado.");
                            return;
                        }

                        const token = response.data.payload.accessToken;
                        localStorage.setItem(AUTH_TOKEN, token);
                        commit(AUTH_SUCCESS, token);
                        resolve(response);
                    }
                })
                .catch(err => {
                    commit(AUTH_ERROR, "Credenciales incorrectas");
                    localStorage.removeItem(AUTH_TOKEN);
                    reject(err);
                });
        });
    },
    [AUTH_LOGOUT]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_LOGOUT);
            $('body').addClass('blank');
            localStorage.removeItem(AUTH_TOKEN)
            resolve()
        })
    }
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, token) => {
        state.status = 'success';
        state.token = token;
        state.hasLoadedOnce = true
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
        state.hasLoadedOnce = true
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = ''
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js